// extracted by mini-css-extract-plugin
export default {"Checkbox":"LabelCheckbox_Checkbox__gdB2-"};